var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RestService } from "../RestService";
const URL = "/appInfo";
export class AppInfoApi extends RestService {
    getAll() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.get(URL);
            if (res.ok)
                return res.data;
            return null;
        });
    }
    getByTitle(title) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.get(`${URL}/${title}`);
            if (res.ok)
                return res.data;
            return null;
        });
    }
    create(appInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.post(URL, appInfo, this.headers.json);
            return res.ok;
        });
    }
    update(appInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.put(URL, appInfo, this.headers.json);
            return res.ok;
        });
    }
    delete(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${URL}/${id}`;
            const res = yield this.httpClient.delete(url);
            return res.ok;
        });
    }
}
//# sourceMappingURL=AppInfoApi.js.map